var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center gap-[10px] pb-10 md:flex-row md:justify-between"},[_c('div',{staticClass:"flex"},[_c('img',{staticClass:"w-[125px] h-[17px]",attrs:{"src":require("../../assets//images/logo.svg"),"alt":"Image"}})]),_c('div',{staticClass:"text-base"},[_vm._v(" © 2024 OneOrder Technologies Inc. ")])])
}]

export { render, staticRenderFns }